import { render, staticRenderFns } from "./lay-out.vue?vue&type=template&id=3da8f8a6&scoped=true&"
import script from "./lay-out.vue?vue&type=script&lang=js&"
export * from "./lay-out.vue?vue&type=script&lang=js&"
import style1 from "./lay-out.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3da8f8a6",
  null
  
)

export default component.exports